import { httpClient } from '@/utils/httpClient';

export type MaintenanceRequestStatusLabel = 'Pending' | 'Partially Received' | 'Complete';

export interface MaintenanceRequestLogViewRow {
  id: string;
  entity_identifier: string | null;
  display_name: string | null;
  entity_data: Record<string, unknown> | null;
  status: string | null;
  created_at: string;
  updated_at: string;
  document_entity_identifier: string | null;
  document_number: string | null;
  date_sent: string;
  total_quantity: number;
  received_quantity: number;
  outstanding_quantity: number;
  status_label: MaintenanceRequestStatusLabel;
  is_complete: boolean;
  asset_names_agg: string | null;
  lins_agg: string | null;
  nsns_agg: string | null;
}

export interface MaintenanceRequestLogItemViewRow {
  id: string;
  asset_name: string | null;
  lin: string | null;
  nsn: string | null;
  sent_quantity: number;
  received_quantity: number;
  asset_ids: string[];
  maintenance_request_id: string;
  /** @deprecated Use maintenance_request_id instead */
  maintenance_send_transaction_id: string;
}

export interface MaintenanceRequestReceivableItemViewRow {
  id: string;
  asset_name: string;
  location_id: string | null;
  location_name: string;
  location_path: string;
  lin: string | null;
  nsn: string | null;
  status_key: string | null;
  is_true_location: boolean;
  stock_quantity: number;
  asset_ids: string[];
  catalog_id: string | null;
  has_catalog_image: boolean;
  document_number: string | null;
  maintenance_request_id: string;
  /** @deprecated Use maintenance_request_id instead */
  maintenance_send_transaction_id: string;
}

class MaintenanceRequestLogsService {
  async listLogs(): Promise<MaintenanceRequestLogViewRow[]> {
    return httpClient.get<MaintenanceRequestLogViewRow[]>(
      `/api/rest/data/v1/maintenance_request_logs_view?order=date_sent.desc`,
    );
  }

  async getLogItems(maintenanceRequestId: string): Promise<MaintenanceRequestLogItemViewRow[]> {
    return httpClient.get<MaintenanceRequestLogItemViewRow[]>(
      `/api/rest/data/v1/maintenance_request_log_items_view?maintenance_request_id=eq.${maintenanceRequestId}`,
    );
  }

  async getReceivableItems(
    maintenanceRequestId: string,
  ): Promise<MaintenanceRequestReceivableItemViewRow[]> {
    return httpClient.get<MaintenanceRequestReceivableItemViewRow[]>(
      `/api/rest/data/v1/maintenance_request_receivable_items_view?maintenance_request_id=eq.${maintenanceRequestId}`,
    );
  }
}

export const maintenanceRequestLogsService = new MaintenanceRequestLogsService();
